// extracted by css-extract-rspack-plugin
export default {"finePrintContainer":"auth-flow-promo-offer-fine-print-module__finePrintContainer___P2OZz","finePrint":"auth-flow-promo-offer-fine-print-module__finePrint___Fklfh"};